export default {"src":"/_next/static/media/14.40625296.svg","height":44,"width":44};